var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeeprFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 415,
    height: 113,
    viewBox: "0 0 415 113",
    fill: "none",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.1 85.8L150.7 42.7H150.4V85.8H134.7V0.600006H150.4V39.5H150.7L175.1 0.600006H191.6L165 40L193.1 85.8H175.1Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.4 52.6H208.6L209.5 51L232.2 44.7C232.2 32.7 227.4 27.1 219.1 27.1C210.3 27.1 204.2 34.3 204.6 50.3C204.6 50.3 204.7 54.2 205 57.7C205.8 69.7 212.7 76.6 223.7 76.6C231.4 76.6 236.9 74.7 240.5 72.9L244.1 82.4C239.4 85 232.2 87.1 222.1 87.1C203.2 87.1 191.1 74.8 191.1 52.3C191.1 30.5 202.1 17.9 219.6 17.9C237.3 17.9 247 29.9 246.3 52.3V52.6H246.4Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.8 52.6H269L269.9 51L292.6 44.7C292.6 32.7 287.8 27.1 279.5 27.1C270.7 27.1 264.6 34.3 265 50.3C265 50.3 265.1 54.2 265.4 57.7C266.2 69.7 273.1 76.6 284.1 76.6C291.8 76.6 297.3 74.7 300.9 72.9L304.5 82.4C299.8 85 292.6 87.1 282.5 87.1C263.6 87.1 251.5 74.8 251.5 52.3C251.5 30.5 262.5 17.9 280 17.9C297.7 17.9 307.4 29.9 306.7 52.3V52.6H306.8Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.3 86.7C335.5 86.7 331.5 86.2 329.3 85.3V112.4H314.3V22.6C319.4 19.9 326.8 17.8 337.5 17.8C356.9 17.8 368.7 30.3 368.7 51.6C368.6 73.4 356.8 86.7 339.3 86.7ZM337.1 26.9C333.8 26.9 331.4 27.4 329.3 28.3V76.6C331 77.3 333.3 77.7 336 77.7C347.9 77.7 353.7 68.4 353.7 52.2C353.7 36.2 349.3 26.9 337.1 26.9Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M405.3 29C400.2 27.3 394.7 27.5 391.2 29.5V85.8H376.1V22.6C383 19.3 391.5 17.4 408.3 17.9C413.3 17.9 415.1 22.6 414.2 25.2C413.3 27.9 410.4 30.8 405.3 29Z",
    fill: "#9E9E9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9 56.2L90.9 91.3C100.4 81.8 105.9 69.5 106.7 56.2H55.9Z",
    fill: "#9E9E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.3 50.4C103 22.9 80.4 1 52.5 1C23.9 1 0.699997 24.2 0.699997 52.8C0.699997 81.4 23.9 104.6 52.5 104.6C59.4 104.6 65.9 103.3 71.9 100.8L61.4 74.7V84.7C58.6 85.5 55.6 85.9 52.5 85.9C34.2 85.9 19.3 71.1 19.3 52.7C19.3 34.4 34.1 19.5 52.5 19.5C65.7 19.5 77 27.2 82.4 38.3L52.5 52.7L104.3 50.4Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeprFooterLogo);
export default __webpack_public_path__ + "static/media/keepr-footer-logo.57f355fcaa96d5aad001cab0150f6489.svg";
export { ForwardRef as ReactComponent };